import React from 'react';

const logos = [
  'StartUp',
  'Indie Hackers',
  'StripeScale',
  'CloudNest',
  'Buildly',
  'Shipfast',
];

const TrustedBy = () => (
  <div className="lp-trusted" aria-label="Trusted by">
    <div className="lp-container">
      <p className="lp-trusted-label">Trusted by builders at</p>
      <div className="lp-trusted-row">
        {logos.map((name) => (
          <span key={name} className="lp-trusted-logo">{name}</span>
        ))}
      </div>
    </div>
  </div>
);

export default TrustedBy;
